/**
 *
 *
 *
 *
 *
 */
export function assignNamespace(parent, key, implementation, legacy) {
    parent[key] = Object.assign(parent[key] ?? {}, implementation, legacy);
    return parent[key];
}
